import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import hasRole from '../helpers/hasRole';
import UserContext from '../contexts/userContext';
var UserRoleCheck = function (_a) {
    var children = _a.children, roles = _a.roles;
    var user = useContext(UserContext).user;
    if (!user || !roles.some(function (role) { return hasRole(user, role); })) {
        return _jsx(_Fragment, {});
    }
    return _jsx(_Fragment, { children: children });
};
export default UserRoleCheck;
